import React, { useState } from 'react';
import { Input } from 'antd';
import s from '../../s.module.less';

const maskSSN = (raw: string) => {
    const d = (raw || '').replace(/\D/g, '');
    return d ? `•••-••-${d.slice(-4)}` : '';
};

const EyeOn = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} width={18} height={18}>
        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
        <circle cx="12" cy="12" r="3" />
    </svg>
);

const EyeOff = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} width={18} height={18}>
        <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
        <line x1="1" y1="1" x2="23" y2="23" />
    </svg>
);

// 掩码 SSN：默认只显示后 4 位。revealed 单一状态控制明文/掩码，眼睛按钮直接切换它；
// 聚焦自动显示明文以便编辑，失焦一律重新打码（避免反复点击后残留明文）。对齐原型 .cred-ssn-input。
export default function SsnInput({ value = '', onChange }: { value?: string; onChange?: (v: string) => void }) {
    const [revealed, setRevealed] = useState(false);
    const display = revealed ? value : maskSSN(value);

    return (
        <Input
            size="large"
            className={s.ssnInput}
            placeholder="XXXXXXXXX"
            maxLength={9}
            autoComplete="off"
            inputMode="numeric"
            value={display}
            onChange={(e) => {
                // 掩码态（含 • 圆点）绝不把掩码串写回真实值，防止 SSN 被覆盖成后 4 位
                if (e.target.value.includes('•')) return;
                // 只接受数字：连字符等分隔符一律剥掉，存 9 位纯数字（粘贴 123-45-6789 也会被规整）
                onChange?.(e.target.value.replace(/\D/g, '').slice(0, 9));
            }}
            onFocus={() => setRevealed(true)}
            onBlur={() => setRevealed(false)}
            suffix={
                <button
                    type="button"
                    className={s.ssnEye}
                    aria-label={revealed ? 'Hide SSN' : 'Show SSN'}
                    onMouseDown={(e) => e.preventDefault()}
                    onClick={() => setRevealed((r) => !r)}
                >
                    {revealed ? <EyeOff /> : <EyeOn />}
                </button>
            }
        />
    );
}
